import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { LinearProgress, Tab, Tabs, Typography } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import { Theme, makeStyles } from '@material-ui/core/styles'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import clsx from 'clsx'
import { ImportPagePreviewResponse } from 'models/projectImport'
import { ProjectSettings } from 'models/projectSettings'
import { SectionParagraph } from 'models/specificationSection'
import { getFilteredParagraphForPreview } from 'pages/ProjectsPage/WorkspacePage/components/Common/utils'
import React from 'react'
import ImportPreviewParagraphs from './Components/ImportPreviewParagraphs'
const a11yProps = (index: number) => {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
        'data-testid': `customTab${index}`,
    }
}
const useStyle = makeStyles((theme: Theme) => ({
    tabRoot: {
        color: (props: ImportPreviewStyleProps) =>
            props.isBPImport ? theme.palette.common.white : 'inherit',
        backgroundColor: (props: ImportPreviewStyleProps) =>
            props.isBPImport ? '#73828C' : theme.palette.common.white,
        borderRadius: '4px 4px 0px 0px',
        maxWidth: 140,
        minWidth: 140,
        marginRight: theme.spacing(0.75),
    },
    fileTitle: {
        fontWeight: 'bold',
    },
    greyText: {
        color: theme.palette.grey[500],
        fontSize: pxToRem(14),
        textAlign: 'center',
    },
    notUsedContainer: {
        textAlign: 'center',
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: theme.palette.common.white,
    },

    tabActive: {
        backgroundColor: (props: ImportPreviewStyleProps) =>
            props.isBPImport ? theme.palette.common.white : '#304959',
        color: (props: ImportPreviewStyleProps) =>
            props.isBPImport ? '#37424A' : theme.palette.common.white,

        border: '1px solid #73828C',
        borderBottom: 0,
    },

    expandCollapseButton: {
        borderRadius: theme.spacing(2.5),
        color: '#04325B',
        lineHeight: 1.43,
        padding: theme.spacing(1),
        height: 32,
    },
    container: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: theme.palette.background.paper,
        height: '100%',
    },
    buttonLabel: {
        lineHeight: '16px',
        '& .MuiButton-endIcon': {
            marginLeft: 0,
        },
    },
    previewWrapper: {
        borderRadius: 0,
        overflow: (props: ImportPreviewStyleProps) =>
            props.isBPImport && props.isTableEmpty ? 'none' : 'auto',
        minWidth: 500,
        position: 'relative',
        width: '100%',
        minHeight: 700,
        '& .MuiTabs-root': {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        padding: (props: ImportPreviewStyleProps) =>
            props.isBPImport ? theme.spacing(0, 1.25) : theme.spacing(0, 2.5),
        [theme.breakpoints.between('lg', 'md')]: {
            flex: 2,
            margin: theme.spacing(2),
        },
        [theme.breakpoints.down('md')]: {
            flex: 2,
            margin: theme.spacing(2),
        },
        fontSize: pxToRem(14),

        height: (props: ImportPreviewStyleProps) =>
            props.isBPImport
                ? props.isSelectedFileImported
                    ? 740
                    : 724
                : props.isSelectedFileImported
                ? 720
                : 704,
        //  display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#FFFFFF',
        boxShadow: (props: ImportPreviewStyleProps) =>
            props.isBPImport ? 'none' : '0px 4px 4px rgba(0, 0, 0, 0.25);',
        border: (props: ImportPreviewStyleProps) =>
            props.isBPImport ? '1px solid #DFDFDF' : 'none',
    },
    previewWrapperCollapsed: {
        borderRadius: 0,
        overflow: 'auto',
        minWidth: 500,
        position: 'relative',
        margin: theme.spacing(3.5),
        width: '100%',
        minHeight: 700,
        '& .MuiTabs-root': {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        padding: theme.spacing(0, 2.5),
        [theme.breakpoints.between('lg', 'md')]: {
            flex: 2,
            margin: theme.spacing(2),
        },
        [theme.breakpoints.down('md')]: {
            flex: 2,
            margin: theme.spacing(2),
        },
        fontSize: pxToRem(14),

        height: 770,
        //  display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#FFFFFF',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25);',
    },
    elementTitle: {
        marginTop: theme.spacing(2),
    },
    elementText: {
        fontSize: pxToRem(24),
        lineHeight: '30px',
    },
    elementType: {
        fontSize: pxToRem(14),
        lineHeight: '30px',
        fontWeight: 500,
        textTransform: 'capitalize',
    },
    tabsFixed: {
        position: 'relative',
        width: 455,
        marginBottom: theme.spacing(2),
        borderBottom: '1px solid #DADADA',
        marginTop: theme.spacing(1),
    },
    tabsContainer: {
        marginBottom: theme.spacing(1),
        borderBottom: '1px solid #DADADA',
    },
    expandCollapseContainer: {
        display: 'flex',
        '& button:first-child': {
            marginRight: theme.spacing(1),
        },
        marginBottom: theme.spacing(1),
        marginRight: 0,
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    tabsIndicator: {
        border: 'none',
        height: 0,
    },
    progressBar: {
        '& .MuiLinearProgress-barColorPrimary': {
            backgroundColor: '#33B55B',
        },
        background: theme.palette.common.white,
        border: '1px solid #33B55B',
        marginBottom: theme.spacing(1),
        boxSizing: 'border-box',
        borderRadius: '150px',
        marginLeft: theme.spacing(0.5),
        height: 20,
        width: 300,
        '& .MuiLinearProgress-bar1Indeterminate .MuiLinearProgress-barColorPrimary': {
            background: '#33B55B',
            borderRadius: '100px',
            backgroundColor: '#33B55B',
        },
        '& .MuiLinearProgress-bar2InDeterminate': {
            background: '#33B55B',
            borderRadius: '100px',
            backgroundColor: '#33B55B',
        },
    },
    previewText: {
        top: 20,
        left: 1175,
        fontSize: pxToRem(14),
    },
    noDataContainer: {
        overflow: 'hidden',
    },
    printPage: {
        background: theme.palette.common.white,
        position: 'relative',
        margin: 'auto',
        height: (props: ImportPreviewStyleProps) =>
            props.isBPImport ? '100%' : 'inherit',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
    },
    textArea: {
        width: 670,
        position: 'relative',
        left: theme.spacing(12),
        top: theme.spacing(0),
        bottom: theme.spacing(6),
        paddingBottom: theme.spacing(6),
    },
}))
interface ImportPreviewStyleProps {
    isBPImport?: boolean
    isTableEmpty?: boolean
    isSelectedFileImported?: boolean
}
export interface ImportPreviewSectionProps extends ImportPreviewStyleProps {
    previewLoading?: boolean
    importPreviewData?: Partial<ImportPagePreviewResponse> | null
    settings?: Partial<ProjectSettings> | undefined
    selectedTypeName?: string
    selectedRowType?: string
    selectedTextType?: string
    actionBarCollapsed?: boolean
}

const ImportPreviewSection: React.FC<ImportPreviewSectionProps> = ({
    importPreviewData,
    previewLoading,
    settings,
    selectedTypeName,
    selectedRowType,
    selectedTextType,
    isTableEmpty,
    actionBarCollapsed,
    isBPImport,
    isSelectedFileImported,
}) => {
    const classes = useStyle({
        isBPImport: isBPImport,
        isTableEmpty: isTableEmpty,
        isSelectedFileImported: isSelectedFileImported,
    })
    let container = document.getElementById('root')
    const lastFocusedExpandCollapseIconRef = React.useRef<number | null>(null)
    const [localTab, setLocalTab] = React.useState<number>(0)
    const [expandedArticles, setExpandedArticles] = React.useState<string[]>([])
    const handleChange = (_event: React.ChangeEvent<{}>, newValue: number) => {
        setLocalTab(newValue)
    }
    const [isProductTypePreview, setIsProductTypePreview] = React.useState<
        boolean
    >(false)
    const previewParts = React.useMemo(() => {
        return importPreviewData?.sectionPreview?.paragraphs?.filter(
            (item) => item?.type === 'Part'
        )
    }, [importPreviewData])
    const emptyDataOnTabs = React.useMemo(() => {
        return (
            isProductTypePreview ||
            previewParts?.[localTab]?.children?.length === 0
        )
    }, [isProductTypePreview, previewParts])
    const firstArticleIndex: number =
        React.useMemo(() => {
            if (
                importPreviewData?.sectionPreview?.sectionNumber?.substring(
                    0,
                    2
                ) === '00'
            ) {
                return importPreviewData?.sectionPreview?.paragraphs?.[0]?.children?.findIndex(
                    (item) => item?.type === 'Article'
                )
            } else return -1
        }, [importPreviewData]) ?? -1
    const handleExpandClick = React.useCallback(
        (selectedArticle?: Partial<SectionParagraph>, expandAll?: boolean) => {
            if (expandAll) {
                const allArticles: string[] = importPreviewData?.sectionPreview?.paragraphs
                    ?.filter((item) => item.type === 'Part')
                    ?.[localTab]?.children?.map(
                        (item) => item.content?.[0]?.text!
                    )!

                const productTypeArticles =
                    importPreviewData?.sectionPreview?.paragraphs?.filter(
                        (item) => item.type === 'Part'
                    )?.length === 1
                        ? importPreviewData?.sectionPreview?.paragraphs
                              ?.filter((item) => item.type === 'Part')?.[0]
                              ?.children?.map(
                                  (item) => item.content?.[0]?.text!
                              )!
                        : []

                setExpandedArticles(
                    allArticles ? allArticles : productTypeArticles
                )
            } else {
                const articleTitle = selectedArticle?.content?.[0]?.text
                setExpandedArticles([...expandedArticles!, articleTitle!])
            }
        },
        [expandedArticles, localTab, importPreviewData]
    )
    const handleCollapseClick = React.useCallback(
        (
            selectedArticle?: Partial<SectionParagraph>,
            collapseAll?: boolean
        ) => {
            if (collapseAll) {
                setExpandedArticles([])
            } else {
                const articleTitle = selectedArticle?.content?.[0]?.text
                setExpandedArticles(
                    expandedArticles.filter((item) => item !== articleTitle)
                )
            }
        },
        [expandedArticles]
    )
    const renderNoUsed = React.useMemo(() => {
        if (isProductTypePreview) {
            const productTypeChildren = getFilteredParagraphForPreview(
                previewParts?.filter(
                    (item) => item?.content?.[0]?.text === 'PRODUCTS'
                )?.[0]?.children!
            )
            if (
                localTab === 0 ||
                localTab === 2 ||
                productTypeChildren?.length === 0
            ) {
                return (
                    <div
                        className={clsx(
                            classes.notUsedContainer,
                            classes.greyText
                        )}
                    >
                        Not Used
                    </div>
                )
            }
        } else if (
            getFilteredParagraphForPreview(previewParts?.[localTab]?.children!)
                ?.length === 0
        ) {
            return (
                <div
                    className={clsx(classes.notUsedContainer, classes.greyText)}
                >
                    Not Used
                </div>
            )
        } else return
    }, [previewParts, localTab, isProductTypePreview])
    React.useEffect(() => {
        if (importPreviewData) {
            setExpandedArticles([])
            if (selectedRowType === 'ProductType') {
                setLocalTab(1)
                setIsProductTypePreview(true)
            } else {
                setLocalTab(0)
            }
        } else {
            setLocalTab(0)
        }
    }, [selectedRowType, importPreviewData])
    React.useEffect(() => {
        if (container && container.children) {
            let requiredChild = container.children[0].children[1]
            requiredChild.classList.add(classes.noDataContainer)
        }
    }, [container])
    React.useEffect(() => {
        if (
            previewParts?.length === 1 &&
            selectedRowType === 'ProductType' &&
            previewParts?.[0]?.content?.[0]?.text === 'PRODUCTS' &&
            previewParts?.[0]?.children?.length !== 0
        ) {
            setIsProductTypePreview(true)
        } else {
            setIsProductTypePreview(false)
        }
    }, [previewParts, selectedRowType])

    return (
        <div
            className={
                actionBarCollapsed
                    ? classes.previewWrapperCollapsed
                    : classes.previewWrapper
            }
        >
            {!previewLoading &&
            importPreviewData?.sectionPreview?.paragraphs !== undefined &&
            importPreviewData?.sectionPreview?.paragraphs?.length !== 0 ? (
                <>
                    <GridItem
                        className={classes.elementTitle}
                        data-testid="elementTitle"
                    >
                        <Typography className={classes.elementText}>
                            {selectedTypeName}
                        </Typography>
                        <Typography className={classes.elementType}>
                            {selectedRowType === 'ProductType'
                                ? 'Product Type'
                                : selectedRowType}
                        </Typography>
                    </GridItem>
                    <>
                        <Tabs
                            value={localTab}
                            onChange={handleChange}
                            aria-label="product-family"
                            variant="fullWidth"
                            scrollButtons="off"
                            classes={{
                                fixed: classes.tabsFixed,
                                indicator: classes.tabsIndicator,
                            }}
                        >
                            <Tab
                                label="General"
                                {...a11yProps(0)}
                                className={clsx(
                                    localTab === 0 && classes.tabActive
                                )}
                                classes={{
                                    root: classes.tabRoot,
                                }}
                                tabIndex={0}
                            />
                            <Tab
                                label="Product"
                                {...a11yProps(1)}
                                className={clsx(
                                    localTab === 1 && classes.tabActive
                                )}
                                classes={{
                                    root: classes.tabRoot,
                                }}
                                tabIndex={0}
                            />
                            <Tab
                                label="Execution"
                                {...a11yProps(2)}
                                className={clsx(
                                    localTab === 2 && classes.tabActive
                                )}
                                classes={{
                                    root: classes.tabRoot,
                                }}
                                tabIndex={0}
                            />
                            <GridContainer
                                item
                                className={classes.expandCollapseContainer}
                            >
                                <Button
                                    className={clsx(
                                        classes.expandCollapseButton,
                                        'expand-all-button'
                                    )}
                                    data-testid="btnExpandAll"
                                    variant="outlined"
                                    endIcon={<KeyboardArrowDownIcon />}
                                    onClick={() =>
                                        handleExpandClick(undefined, true)
                                    }
                                    classes={{
                                        label: classes.buttonLabel,
                                    }}
                                    role="tab"
                                >
                                    Expand All
                                </Button>
                                <Button
                                    className={clsx(
                                        classes.expandCollapseButton,
                                        'collapse-all-button'
                                    )}
                                    data-testid="btnCollapseAll"
                                    variant="outlined"
                                    endIcon={<KeyboardArrowDownIcon />}
                                    onClick={() =>
                                        handleCollapseClick(undefined, true)
                                    }
                                    classes={{
                                        label: classes.buttonLabel,
                                    }}
                                    role="tab"
                                >
                                    Collapse All
                                </Button>
                            </GridContainer>
                        </Tabs>
                    </>
                    {renderNoUsed}

                    <div id={`simple-tabpanel-${localTab}`}>
                        <ImportPreviewParagraphs
                            selectedFamilyId={
                                importPreviewData?.sectionPreview?.sectionNumber
                            }
                            firstArticleIndex={firstArticleIndex}
                            data={[
                                [
                                    {
                                        children:
                                            isProductTypePreview ||
                                            previewParts?.[0]?.children
                                                ?.length === 0
                                                ? []
                                                : getFilteredParagraphForPreview(
                                                      previewParts?.[0]
                                                          ?.children!
                                                  ),
                                        content:
                                            isProductTypePreview ||
                                            previewParts?.[0]?.children
                                                ?.length === 0
                                                ? []
                                                : previewParts?.[0]?.content,
                                        hierarchicalLevel: 0,
                                        index: 0,
                                        type: 'Part',
                                    },
                                    {
                                        children: isProductTypePreview
                                            ? getFilteredParagraphForPreview(
                                                  previewParts?.[0]?.children!
                                              )
                                            : getFilteredParagraphForPreview(
                                                  previewParts?.[1]?.children!
                                              ),
                                        content: isProductTypePreview
                                            ? previewParts?.[0]?.content
                                            : previewParts?.[1]?.content,
                                        hierarchicalLevel: 0,
                                        index: 1,
                                        type: 'Part',
                                    },
                                    {
                                        children:
                                            isProductTypePreview ||
                                            previewParts?.[2]?.children
                                                ?.length === 0
                                                ? []
                                                : getFilteredParagraphForPreview(
                                                      previewParts?.[2]
                                                          ?.children!
                                                  ),
                                        content:
                                            isProductTypePreview ||
                                            previewParts?.[2]?.children
                                                ?.length === 0
                                                ? []
                                                : previewParts?.[2]?.content,
                                        hierarchicalLevel: 0,
                                        index: 2,
                                        type: 'Part',
                                    },
                                ]?.[localTab],
                            ]}
                            selectedTab={localTab}
                            parentCount={0}
                            settings={settings}
                            handleExpandClick={handleExpandClick}
                            handleCollapseClick={handleCollapseClick}
                            expandedArticles={expandedArticles}
                            lastFocusedExpandCollapseIconRef={
                                lastFocusedExpandCollapseIconRef
                            }
                        />
                    </div>
                </>
            ) : previewLoading && !isTableEmpty ? (
                <div className={classes.printPage}>
                    <LinearProgress
                        className={classes.progressBar}
                        variant="indeterminate"
                        data-testid="importPreviewProgress"
                    />
                    {'\n'}
                    <span className={classes.fileTitle}>
                        {selectedTypeName}
                    </span>
                    This may take few seconds...
                </div>
            ) : !previewLoading && !isTableEmpty ? (
                <div className={classes.printPage}>
                    {' '}
                    Add a File to Preview your Import
                </div>
            ) : null}
        </div>
    )
}

export default ImportPreviewSection
